import React, { useContext, useEffect, useState, useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the styles
import "../styles/accountSettings.css";
import userDefaultImage from "../images/default-profile.png";
import LoadingIcon from "../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UserContext } from "../contexts/UserContext";
import { UrlContext } from "../contexts/UrlContext";
import linkedinGray from "../images/linkedin-3-16.png";
import ephLogo from "../images/logo.png";
import SelectImage from "../components/ManageUsers/UserLogo";

export default function AccountSettings() {
  useEffect(() => {
    document.title = "Account Settings";
  }, []);
  const { userData, userError, adminUser, accessUser } =
    useContext(UserContext);
  const { API_URL } = useContext(UrlContext);
  const [loading, setLoading] = useState(true);
  const [showSelectImage, setShowSelectImage] = useState(false);
  const [email_z, setEmail_z] = useState("david.kuepper@expertpowerhouse.com");
  const databaseLink = "https://images.expertpowerhouse.com";
  const [userInfo, setUserInfo] = useState({
    username: "",
    path: "",
    just_in_case: "",
    config_just_in_case: "",
    profilePicture: "",
  });
  const [signature, setSignature] = useState("");
  const [htmlContent, setHtmlContent] = useState("");
  const [htmlContentToDisplay, setHtmlContentToDisplay] = useState("");
  const [designation, setDesignation] = useState("");
  const [sigFirstName, setSigFirstName] = useState("");
  const [sigLastName, setSigLastName] = useState("");
  const [sigTitle, setSigTitle] = useState("");
  const [linkedInEmail, setLinkedInEmail] = useState("");
  const [linkedInPass, setLinkedInPass] = useState("");
  const [contactNo, setContactNo] = useState("");
  const previewRef = useRef(null);

  const [linkedinLogo64, setLinkedinLogo64] = useState(
    "https://images.expertpowerhouse.com/pictures/linkedin-3-16.png"
  );
  const [ephLogo64, setEphLogo64] = useState(
    "https://images.expertpowerhouse.com/pictures/ephlogo.png"
  );
  const [loadingPopup, setLoadingPopup] = useState(false);
  // const ephLogo = require("../images/eph_logo.png").default

  // const convertImageToBase64 = async () => {
  //   try {
  //     const response = await fetch(ephLogo);
  //     const blob = await response.blob();
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setEphLogo64(reader.result);
  //     };
  //     reader.readAsDataURL(blob);
  //   } catch (error) {
  //     console.error('Error converting image to Base64:', error);
  //   }

  //   try {
  //     const response = await fetch(linkedinGray);
  //     const blob = await response.blob();
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setLinkedinLogo64(reader.result);
  //     };
  //     reader.readAsDataURL(blob);
  //   } catch (error) {
  //     console.error('Error converting image to Base64:', error);
  //   }
  // };

  useEffect(() => {
    // convertImageToBase64()
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}account-settings`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const new_config = data.user.config_just_in_case.replace(/\s{2,}/g, "");
        data.user.config_just_in_case = new_config;
        setUserInfo(data.user);
        setLoading(false);
        setDesignation(data.user.config);
        setContactNo(data.user.path_z);
        setSigFirstName(data.user.sigfirstname);
        setSigLastName(data.user.siglastname);
        setSigTitle(data.user.sigtitle);
        setLinkedInEmail(data.user.linkedInEmail);
        setLinkedInPass(data.user.linkedInPass);
        setHtmlContent(data.signature);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    getSignature();
  }, [ephLogo64, userInfo]);

  const customStyles = {
    // Add your custom styles here
    maxWidth: "100%", // Set maximum width for images
  };

  useEffect(() => {
    // Apply inline styles to all img elements inside the rendered HTML
    if (previewRef.current) {
      const imgs = previewRef.current.querySelectorAll("img");
      const lastThreeImgs = Array.from(imgs).slice(-3);
      lastThreeImgs.forEach((img, index) => {
        if (index !== 1) {
          console.log(img);
          img.style.width = "auto";
          img.style.height = "auto";
          img.style.maxWidth = "100%";
          img.style.maxHeight = "1000px"; // Adjust as needed
        } else {
          img.style.width = "auto";
          img.style.height = "auto";
          img.style.maxWidth = "95px";
          img.style.maxHeight = "150px"; // Adjust as needed
          img.style.marginLeft = "2px";
        }
      });
    }
  }, [htmlContentToDisplay]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];

  const sigRef = useRef(null);

  const getSignature = () => {
    const signature = htmlContent
      .replace("{{name}}", `${sigTitle} ${sigFirstName} ${sigLastName}`)
      .replace("{{designation}}", designation)
      .replace("{{contactNumber}}", contactNo);
    setHtmlContentToDisplay(signature);
  };

  const updateHandler = (e) => {
    e.preventDefault();
    setLoadingPopup(true);
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const url = `${API_URL}account-update`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify(userInfo),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setLoadingPopup(false);
          Swal.fire({
            icon: "success",
            title: "Profile has been updated",
            showConfirmButton: false,
            timer: 1500,
          });
          window.location.reload();
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
  };

  return (
    <>
      <div className="container-div">
        <div className="ac-settings-div">
          {!loading ? (
            <form onSubmit={updateHandler}>
              <h3>
                {userInfo ? `Account Settings for: ${userInfo.username}` : null}
              </h3>
              <span>
                <label
                  htmlFor="upload-button"
                  onClick={() => {
                    setShowSelectImage(true);
                    // console.log(userData)
                    // setDataForImageUpload(userData);
                  }}
                >
                  <img
                    className="rounded-circle user-profile"
                    alt=""
                    title="Click to upload image"
                    src={
                      userInfo.profilePicture?.includes("data:image")
                        ? userInfo.profilePicture
                        : userInfo.profilePicture !== ""
                        ? `${databaseLink}${userInfo.profilePicture}`
                        : userDefaultImage
                    }
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = userDefaultImage;
                    }}
                  />
                </label>
              </span>
              <div className="ac-settings-boxes">
                <div className="ac-settings-box">
                  <span className="ac-settings-label">Default Settings</span>
                  <div
                    class="custom-control custom-control-right custom-switch"
                    style={{ paddingLeft: "50px" }}
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch1-accountSetting-enableEmail"
                      checked={userInfo?.enableClosingEmail}
                      onChange={(e) => {
                        setUserInfo({
                          ...userInfo,
                          enableClosingEmail: e.target.checked,
                        });
                      }}
                    />
                    <label
                      class="custom-control-label"
                      for="customSwitch1-accountSetting-enableEmail"
                    >
                      Enable sending email to Accounting when Closing the
                      project{" "}
                    </label>
                  </div>
                  <div
                    class="custom-control custom-control-right custom-switch"
                    style={{ paddingLeft: "50px" }}
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch1-accountSetting-enableOwnProjects"
                      checked={userInfo?.enableOwnProjects}
                      onChange={(e) => {
                        setUserInfo({
                          ...userInfo,
                          enableOwnProjects: e.target.checked,
                        });
                      }}
                    />
                    <label
                      class="custom-control-label"
                      for="customSwitch1-accountSetting-enableOwnProjects"
                    >
                      Enable to see your projects{" "}
                    </label>
                  </div>
                  <div
                    class="custom-control custom-control-right custom-switch"
                    style={{ paddingLeft: "50px" }}
                  >
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch1-accountSetting-enableSignature"
                      checked={userInfo?.enableSignature}
                      onChange={(e) => {
                        setUserInfo({
                          ...userInfo,
                          enableSignature: e.target.checked,
                        });
                      }}
                    />
                    <label
                      class="custom-control-label"
                      for="customSwitch1-accountSetting-enableSignature"
                    >
                      Enable Signature in Email
                    </label>
                  </div>
                </div>

                <div className="ac-settings-box">
                  <span className="ac-settings-label">Signature Settings</span>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <span
                      className="ac-settings-label"
                      style={{ paddingLeft: "50px" }}
                    >
                      Name
                    </span>
                    <input
                      placeholder="Title"
                      value={sigTitle ? sigTitle : ""}
                      onChange={(e) => {
                        setUserInfo({ ...userInfo, sigtitle: e.target.value });
                        setSigTitle(e.target.value);
                      }}
                      onBlur={(e) => {
                        getSignature();
                      }}
                      style={{ width: "100px", marginLeft: "95px" }}
                    />
                    <input
                      placeholder="First Name"
                      value={sigFirstName ? sigFirstName : ""}
                      onChange={(e) => {
                        setUserInfo({
                          ...userInfo,
                          sigfirstname: e.target.value,
                        });
                        setSigFirstName(e.target.value);
                      }}
                      onBlur={(e) => {
                        getSignature();
                      }}
                      style={{ width: "150px", marginLeft: "10px" }}
                    />
                    <input
                      placeholder="Last Name"
                      value={sigLastName ? sigLastName : ""}
                      onChange={(e) => {
                        setUserInfo({
                          ...userInfo,
                          siglastname: e.target.value,
                        });
                        setSigLastName(e.target.value);
                      }}
                      onBlur={(e) => {
                        getSignature();
                      }}
                      style={{ width: "150px", marginLeft: "10px" }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <span
                      className="ac-settings-label"
                      style={{ paddingLeft: "50px" }}
                    >
                      Designation
                    </span>
                    <input
                      placeholder="Designation for Signature"
                      value={designation ? designation : ""}
                      onChange={(e) => {
                        setUserInfo({ ...userInfo, config: e.target.value });
                        setDesignation(e.target.value);
                      }}
                      onBlur={(e) => {
                        getSignature();
                      }}
                      style={{ width: "350px", marginLeft: "50px" }}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <span
                      className="ac-settings-label"
                      style={{ paddingLeft: "50px" }}
                    >
                      Contact No.
                    </span>
                    <input
                      placeholder="Contact No. for Signature"
                      value={contactNo ? contactNo : ""}
                      onChange={(e) => {
                        setUserInfo({ ...userInfo, path_z: e.target.value });
                        setContactNo(e.target.value);
                      }}
                      onBlur={(e) => {
                        getSignature();
                      }}
                      style={{ width: "350px", marginLeft: "50px" }}
                    />
                  </div>

                  <div
                    className="sigPreview"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingBottom: "10px",
                    }}
                  >
                    <span
                      className="ac-settings-label"
                      style={{ paddingLeft: "50px" }}
                    >
                      Signature Preview
                    </span>
                    <div
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        height: "400px",
                        width: "300px",
                        marginLeft: "50px",
                      }}
                    >
                      <div style={{ marginLeft: "20px" }} ref={previewRef}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: htmlContentToDisplay,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div></div>
              <button type="submit" className="btn base-btn ac-update-btn">
                Update
              </button>
            </form>
          ) : (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <img
                src={LoadingIcon}
                alt="Loading..."
                style={{ height: "50px" }}
              />
            </div>
          )}
        </div>
      </div>
      {showSelectImage ? (
        <SelectImage
          showSelectImage={showSelectImage}
          dataForImageUpload={userInfo}
        />
      ) : null}
      {loadingPopup && (
        <div className="deletePrj-popup-wrapper">
          <div className="tab-pane fade show deletePrj-div">
            <center>
              <p style={{ fontSize: "18px" }}>Please wait . . .</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
